module.exports = __webpack_public_path__ + "img/T6-D-rc_0.95975daf.png";